module.exports = __webpack_public_path__ + "static/media/pablo-sign-up.f09146c2.jpg";